import i18next from "i18next";
import React from "react";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import DynamicForm from "../Form";
import { useTranslation } from "react-i18next";

const IconFormCell = ({ isOpen, toggle, data, modalTitle, fields = null }) => {
  const { t } = useTranslation();
  const generateDynamicFields = (data) => {
    const baseFields = fields || [];
    
    // Générer les champs supplémentaires si configElectricalOutlets existe
    if (data.configElectricalOutlets) {
      try {
        const electricalOutlets = JSON.parse(data.configElectricalOutlets);
        const dynamicFields = Object.keys(electricalOutlets)
          .map(key => {
            const matches = key.match(/^([a-zA-Z]+)(\d+)$/);
            if (!matches) return null;

            const [_, baseText, number] = matches;
            
            return {
              key: key,
              type: key.startsWith('nbCee') ? 'number' : 'text',
              isDisabled: true,
              isInJson: "configElectricalOutlets",
              label: t(baseText) + ` ${number}`
            };
          });

        // Insérer les champs dynamiques avant safetyEquipment
        const safetyIndex = baseFields.findIndex(f => f.key === 'safetyEquipment');
        if (safetyIndex !== -1) {
          return [
            ...baseFields.slice(0, safetyIndex),
            ...dynamicFields,
            ...baseFields.slice(safetyIndex)
          ];
        }
        return [...baseFields, ...dynamicFields];
      } catch (error) {
        console.error('Error parsing configElectricalOutlets:', error);
        return baseFields;
      }
    }
    return baseFields;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size={'xl'}>
      <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
      <ModalBody>
        <div className="container">
          <div className="card">
            <DynamicForm
              fields={generateDynamicFields(data)}
              initialValues={data}
              isDetailMode={true}
              isEdit={true}
              />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default IconFormCell;
